import React from 'react';

export const SingleSelectDropdown = ({ label, options, selected, setSelected }) => {
  return (
    <div className="flex flex-col">
      <label className="mb-1 font-medium">{label}</label>
      <select
        value={selected || ''}
        onChange={(e) => setSelected(e.target.value)}
        className="border px-3 py-2 rounded w-48"
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </select>
    </div>
  );
};
